/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuperadminIntegrationDto } from '../../models/superadmin-integration-dto';

export interface SuperadminControllerGetUserIntegrations$Params {
  uuid: string;
}

export function superadminControllerGetUserIntegrations(http: HttpClient, rootUrl: string, params: SuperadminControllerGetUserIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SuperadminIntegrationDto>>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetUserIntegrations.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SuperadminIntegrationDto>>;
    })
  );
}

superadminControllerGetUserIntegrations.PATH = '/superadmin/users/{uuid}/integrations';
